<template>
  <b-form>
    <b-row>
      <b-col cols="12" class="px-2">
        <div>
          <div class="search-container mb-1">
            <search :on-search-input="onSetValueSearch" />
          </div>
        </div>
      </b-col>
      <b-col cols="12" class="mb-1">
        <overlay-loading :loading="loading.tableData">
          <template #content>
            <b-table
              :fields="fields"
              :items="exportCodeHistoryTable.payload"
              responsive
              bordered
              borderless
              sticky-header
              show-empty
              no-local-sorting
              class="default-static-table"
              :class="{ 'loading-table': loading.tableData }"
            >
              <template #cell(progress)="data">
                <div :class="data.value == 100 && 'color-green'">
                  {{ data.value + "%" }}
                </div>
              </template>
              <template #cell(status_withdraw)="data">
                <div
                  class="export-code-history-status-withdraw"
                  :style="{
                    backgroundColor: resolveExportStatusClass(
                      data.item.status
                    ),
                  }"
                >
                  {{ resolveExportStatusLabel(data.item.status) }}
                </div>
              </template>
              <template #cell(actions_export)="data">
                <b-button
                  class="mr-2 btn-tab-history-mode"
                  :class="data.item.filepath ? 'export' : ''"
                  @click="exportFile(data.item.filepath)"
                  ><icon-export/>
                </b-button>
              </template>
              <template #table-busy>
                <overlay-loading :loading="true" />
              </template>
              <template #empty>
                  <card-no-item :text-no-img="'Item Not Found'" />
              </template>
            </b-table>
          </template>
        </overlay-loading>
      </b-col>
      <b-col cols="12">
        <pagination-with-reorder
          entity-editable
          :pagination="pagination"
          @entityChange="onFilterEntity"
          @pageChange="onPageChange"
        />
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import Upload from "@/@core/components/svg/button/Upload.vue";
import IconExport from "@/@core/components/svg/inventory-history-detail/IconExport.vue";

import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import useExportCodeHistory from "../../hooks/useExportCodeHistory.js";
export default {
  components: {
    Search,
    vSelect,
    PaginationWithReorder,
    Upload,
    IconExport,
  },
  props: {
    templateId: { type: [Number, String], default: 1 },
    templateData: { type: [Object, Array], default: null },
  },
  setup(props) {
    const{
      loading,
      fields,
      pagination,
      exportCodeHistoryTable,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      resolveExportStatusClass,
      resolveExportStatusLabel,
      exportFile,
    } = useExportCodeHistory(props);
    return{
      loading,
      fields,
      pagination,
      exportCodeHistoryTable,
      onPageChange,
      onFilterEntity,
      onSetValueSearch,
      resolveExportStatusClass,
      resolveExportStatusLabel,
      exportFile,
    };
   },
}
</script>

<style scoped>
@import '~@/assets/css/pages/default-static-table.css';
@import '~@/assets/css/override-styles/v-select.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
@import "~@/assets/css/pages/inventory/history-privilege-detail.css";
@import '~@/assets/css/pages/privilege/privilege-code-template/code-template-exportcode.css';
</style>